module.exports = __webpack_public_path__ + "images/ui/icon_input_checkbox_normal_bef9b81cee036e3d7376e9ba9a2a5805.png";